var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-section",style:(("background-image: url(" + (require('@/assets/images/' + _vm.picture)) + ")"))},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }